import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { miningPoolsState, useAllPoolAPIs, useUserState } from '../../api';
import { delay } from '../utils';

type SignInStatus = null | 'waiting' | 'failed' | 'error' | object;

export const useLoginMiningAccount = (onSuccess?: () => void) => {
  const miningPoolValues = useRecoilValue(miningPoolsState);
  const [signinStates, setSignInStates] = useState<Record<string, SignInStatus>>(() =>
    Object.fromEntries(miningPoolValues.map(({ name: pn }) => [pn, null]))
  );
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const userStates = Object.fromEntries(miningPoolValues.map(({ name: pn }) => [pn, useUserState(pn)]));

  useEffect(() => {
    if (miningPoolValues.length === 0) return;
    miningPoolValues.map(({ name: pn }): void => {
      const signinState = signinStates[pn];
      const setUserState = userStates[pn][1];
      if (signinState === 'waiting') {
        setUserState((prevState) => ({ ...prevState, isLoading: true }));
      } else if (signinState !== null && typeof signinState === 'object') {
        setUserState(signinState);
        setTimeout(() => onSuccess?.(), 600);
      }
      return null;
    });
  }, [miningPoolValues, signinStates, onSuccess]);

  return async (username: string, password: string) => {
    try {
      const signinResults = await Promise.all(
        miningPoolValues.map(async ({ name: pn }) => {
          setSignInStates((prevState) => ({ ...prevState, [pn]: 'waiting' }));
          await delay(1000);
          setSignInStates((prevState) => ({
            ...prevState,
            [pn]: {
              poolname: pn,
              username,
              signinAt: Date.now(),
              token: 'placeholder',
              isLoading: false,
            },
          }));

          return true;
        })
      );
      if (!signinResults.includes(true)) {
        return { error: 'Failed signing in any pool.' };
      }
      return { error: undefined };
    } catch (error) {
      console.error(error);
      return { error: 'Failed signing in any pool.' };
    }
  };
};
